<template>
  <div>
    <!-- Filter Toggle Button -->
    <button
      @click="toggleFilters"
      class="flex items-center btn-primary px-5 py-2.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
    >
      <svg
        class="h-5 w-5 mr-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          :class="{ hidden: showFilters, block: !showFilters }"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1h-16a1 1 0 01-1-1v-2zM4 11h16M4 17h16"
        />
        <path
          :class="{ block: showFilters, hidden: !showFilters }"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <span>{{ showFilters ? "Hide Filters" : "Show Filters" }}</span>
    </button>

    <!-- Filters Options -->
    <transition name="fade">
      <div
        v-if="showFilters"
        class="glass-card mt-6 p-6 rounded-xl shadow-xl grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
      >
        <!-- Dynamic Filters -->
        <div v-for="filter in filters" :key="filter.name" class="filter-item">
          <label
            :for="filter.name"
            class="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-2"
          >
            {{ filter.label }}
          </label>
          <div class="relative">
            <GlassSelect
              :id="filter.name"
              v-model="selectedFilters[filter.name]"
              @change="applyFilters"
              :options="filter.options"
              :valueKey="'value'"
              :labelKey="'label'"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GlassSelect from "@/components/GlassSelect.vue";

export default {
  name: "FiltersSection",
  components: {
    GlassSelect,
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:selectedFilters", "applyFilters", "update:showFilters"],
  methods: {
    toggleFilters() {
      this.$emit("update:showFilters", !this.showFilters);
    },
    applyFilters() {
      this.$emit("applyFilters");
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
